import React from "react";
import Accordion from "../accordion/accordion.component";

const AccordionGroup = ({accordionList = [], title, tab}) => {
  const handleAccordionClick = (title, event) => {
    const details = event.target.closest('details');

    if(details && details.id) {
      updateURL("p", event.target.closest('details').id);
    }

    closeOpenAccordions(event, '.accordion');
  };

  const handleAccordionGroupClick = (title, event) => {
    closeOpenAccordions(event, '.criteria-accordion');
  };

  const closeOpenAccordions = (event, parentSelector) => {
    const currentAccordion = event.target.closest('.accordion');
    const parentAccordion = currentAccordion.parentElement.closest(parentSelector);
    const accordions = parentAccordion.querySelectorAll('.accordion:open');

    for(let acc of accordions) {
      if(acc !== currentAccordion && acc !== parentAccordion) {
        acc.removeAttribute("open");
      }
    }
  };

  const updateURL = (param, id) => {
    const url = new URL(window.location);
    url.searchParams.set("p", id);
    window.history.pushState({}, "", url);
  };

  return (
    <section className='accordion-group' aria-label={title + " Accordion Group"}>
      <Accordion key={title} title={title} onClick={handleAccordionGroupClick} id={title}>
        {accordionList.length > 0 &&
        accordionList
          .sort((accordion, accordionNext) => {
            if (accordion.title < accordionNext.title) return -1;
            if (accordion.title > accordionNext.title) return 1;
            return 0;
          })
          .map(({id, title, children, target}) => {
            return (
              <Accordion key={title} id={id || (tab + '_' + title.split(" ").join(""))} title={title} target={target} onClick={handleAccordionClick}>
                {
                  children.map((child, i) => React.cloneElement(child, {key: i}))
                }
              </Accordion>
            )
          })
        }
      </Accordion>
    </section>
  );
}

export default AccordionGroup;
